import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import React, { useEffect, useState } from 'react';
import AddLeaveModal from './AddLeaveModal';
import Event from './Event';
import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { getLeaveForSelectedMonth } from 'src/services/yearPlannerService';
import moment from 'moment';

interface CalenderProps {
  isGetDataChild?: Boolean;
}

const Calander: React.FC<CalenderProps> = ({ isGetDataChild }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');
  const [selectedEventDescription, setSelectedEventDescription] = useState('');
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const calendarRef: any = React.createRef();
  const monthPickerRef: any = React.createRef();
  const [loadedEvents, setLoadedEvents] = useState([]);
  const [resDates, setResDates] = useState([]);
  const [isEditModal, setIsEditModal] = useState(false);

   //All day type value
   const dayTypes = [
    { label: 'Full day', value: '0' },
    { label: 'Half day- Morning ', value: '1' },
    { label: 'Half day- Evening', value: '2' }
  ];

  const commonTextColor = '#000000';
  const commonBackgroundColor = '#DCE7F2';

  const updateLeaveColor = (leaves: any) => {
    (leaves || []).map((item, i) => {
      item.textColor = commonTextColor;
      item.color = commonBackgroundColor;
      item.title = item.description;
      item.date = moment(item.eventDate).format("YYYY-MM-DD");
      item.type = item.calenderType;
      item.dayType = dayTypes.filter((element) => Number(element.value) === item.dayType)[0].label;
    });
    return leaves;
  };

  // close Modal
  const handleClose = () => {
    setShowModal(false);
    setSelectedDate('');
    setSelectedEvent('');
    setSelectedEventDescription('');
    setIsEditModal(false);

    getLeaveForSelectedMonth(
      selectedMonth.getMonth() + 1,
      selectedMonth.getFullYear()
    ).then((response: any) => {
      setLoadedEvents(updateLeaveColor(response.data));
    }).catch((err: any) => {
      setLoadedEvents(updateLeaveColor([]));
    });
  };

  useEffect(() => {
    handleClose();
  }, [isGetDataChild]);

  // Open add Modal and Edit Modal
  useEffect(() => {
    if (selectedDate) {
      if (resDates.includes(selectedDate)) {
        let currentDate = moment().format("YYYY-MM-DD");
        if(selectedDate > currentDate) {
          setIsEditModal(true);
        }
      } else {
        setIsEditModal(false);
      }
      setShowModal(true);
    }
  }, [selectedDate]);

  useEffect(() => {
    const resDate = loadedEvents.map((res: any) => {
      return res.date;
    })
    setResDates(resDate)
  }, [loadedEvents]);

  const convertDate = (str: string) => {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  };

  const renderEvent = (arg: any) => {
    const eventClick = (res: any) => {
      setSelectedEvent(res.event._def.title);
      setSelectedEventDescription(
        loadedEvents.find(
          (x) => x.date === convertDate(res.event._instance.range.start)
        ).description
      );
    };

    if (arg.textColor === '#00B26A') {
      return (
        <Event
          date={convertDate(arg.event._instance.range.start)}
          onClick={() => {
            eventClick(arg);
          }}
          color={arg.textColor}
          backgroundColor={arg.backgroundColor}
          text={arg.event._def.title}
          dayType={arg.event._def.extendedProps.dayType}
          holidayType={arg.event._def.extendedProps.type}
          id={arg.event._def.publicId}
          handleClose={handleClose}
        />
      );
    } else {
      return (
        <Event
          date={convertDate(arg.event._instance.range.start)}
          color={arg.textColor}
          backgroundColor={arg.backgroundColor}
          text={arg.event._def.title}
          dayType={arg.event._def.extendedProps.dayType}
          holidayType={arg.event._def.extendedProps.type}
          id={arg.event._def.publicId}
          handleClose={handleClose}
        />
      );
    }
  };

  const mobileCheck = () => {
    if (window.innerWidth >= 768) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <AddLeaveModal
        show={showModal}
        handleClose={handleClose}
        date={selectedDate}
        event={selectedEvent}
        description={selectedEventDescription}
        data={loadedEvents}
        isEdit={isEditModal}
      />
      <div>
        <DatePicker
          openTo={mobileCheck() ? 'day' : 'month'}
          ref={monthPickerRef}
          views={mobileCheck() ? ['year', 'month', 'day'] : ['year', 'month']}
          // label="Year and Month"
          minDate={new Date('2022-01-01')}
          maxDate={new Date('2032-12-31')}
          value={selectedMonth}
          onChange={(res: any) => {
            let date = res as Date;
            getLeaveForSelectedMonth(
              date.getMonth() + 1,
              date.getFullYear()
            ).then((response: any) => {
              setLoadedEvents(updateLeaveColor(response.data));
            }).catch((err: any) => {
              setLoadedEvents(updateLeaveColor([]));
            });

            setSelectedMonth(res);
            let calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(res);
          }}
          renderInput={(params: any) => {
            return <TextField {...params} style={{ marginBottom: 10 }} />;
          }}
        />
      </div>
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
        views={{
          newView: {
            type: 'dayGridDay'
          }
        }}
        headerToolbar={false}
        fixedWeekCount={false}
        initialView={mobileCheck() ? 'newView' : 'dayGridMonth'}
        showNonCurrentDates={true}
        selectable={true}
        events={loadedEvents}
        eventContent={renderEvent}
        height={window.innerHeight - window.innerHeight * (40 / 100)}
        expandRows={true}
        displayEventTime={false}
        eventDisplay={'title'}
        handleWindowResize={true}
        dateClick={(res: any) => {
          setSelectedDate(res.dateStr);
        }}
      />
    </>
  );
};
export default Calander;
